// extracted by mini-css-extract-plugin
export default {"content":"index_content_RQk8t","lunbo":"index_lunbo_KqIcS","dotCurrent":"index_dotCurrent_KtKw-","box":"index_box_N3Qqy","image":"index_image_1DBj0","link":"index_link_6SB2H"};